import { environment } from "@environments/environment";

export class ProductImage {
  static getCantoSourceUrl(cantoId: string): string {
    if (!cantoId || cantoId === "" || cantoId === null) return "";
    return `${environment.cantoBaseUrl}/image/${environment.cantoAccountId}/image_${cantoId}/-FPNG-S156x156`;
  }
}
